import useVehiclePageData from '../use-vehicle-page-data'

const AutocheckRedirectUrl = process.env.NEXT_PUBLIC_AUTOCHECK_URL
const siteID = process.env.NEXT_PUBLIC_AUTOCHECK_SITE_ID

export default function HistoryReport() {
  const {
    vehicleData: { vin },
  } = useVehiclePageData()

  const params = new URLSearchParams({ siteID, vin })

  return (
    <div className='root flex alignCenter justifyBetween flexWrap'>
      <a href={`${AutocheckRedirectUrl}/?${params}`} target='_blank' rel='noreferrer'>
        <img src='/images/autocheck-logo.png' alt='autocheck from experian logo' />
      </a>
      <a href={`${AutocheckRedirectUrl}/?${params}`} target='_blank' rel='noreferrer'>
        <p>Click to order AutoCheck</p>
      </a>
      <style jsx>{`
        .root {
          flex: 1;
          padding: 1.6rem 0;
        }
        a {
          margin: 0 0 0;
          max-width: 18.5rem;

          img {
            max-width: 14rem;
            margin: 0 0 0 0;
          }

          p {
            color: var(--primary-color);
            text-align: center;
            font-size: 1.4rem;
          }
        }

        @media (max-width: 1024px) {
          .root {
            margin: 0.5rem 0 0 0.5rem;
          }
          a {
            max-width: 16rem;

            img {
              max-width: 10.6rem;
            }

            p {
              font-size: 1.2rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
